import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface RevenueReceiptAllocatedItem {
  documento: string;
  descrizione: string;
  importo: number;
}

export interface RevenueReceiptDialogData {
  numero: string;
  cliente: string;
  metodo: string;
  importo: number;
  partiteImputate: RevenueReceiptAllocatedItem[];
  email: string;
  agente: string;
  onDownloadPdf?: () => void;
}

@Component({
  selector: 'rev-receipts-receipt-dialog-component',
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './receipts-receipt-dialog-component.html',
  styleUrl: './receipts-receipt-dialog-component.scss',
})
export class receiptsReceiptDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) readonly data: RevenueReceiptDialogData) {}

  formatAmount(value: number): string {
    return `€ ${value.toLocaleString('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }
}
